import { render, staticRenderFns } from "./contactus.vue?vue&type=template&id=bdc8a8da&scoped=true"
import script from "./contactus.vue?vue&type=script&lang=js"
export * from "./contactus.vue?vue&type=script&lang=js"
import style0 from "./contactus.vue?vue&type=style&index=0&id=bdc8a8da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc8a8da",
  null
  
)

export default component.exports